module.exports = __webpack_public_path__ + "img/01f See_651px.b98cbc2c.jpg";